import React from 'react'
import AddIcon from '../../../assets/images/ui/plus.png'
import './style.css'

export default function LoadMoreButton({onClick}) {
    return (
        <div className='LoadMoreButton' onClick={onClick}>
            <img src={AddIcon} />
        </div>
    );
}
